import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    padding: 0.85rem 0;
    font-size: 0.7rem;
    box-shadow: inset 0 -1px 0 #dcdcdc;
    color: #7A05A7;
    background: #f7f7f7;
    margin-left: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
        font-size: 1.5rem;
        margin-right: 0.5rem;
    }
`